


































































import { defineComponent, computed } from '@vue/composition-api';
import { CheckIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'Tab',
    props: {
        tab: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        activeTab: {
            type: Number,
            required: true,
        },
        lastElement: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        breadcrumbMode: {
            type: Boolean,
            default: true,
        },
        totalTabs: {
            type: Number,
            required: true,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        numbered: {
            type: Boolean,
            default: false,
        },
    },
    components: { CheckIcon },
    setup(props, { emit }) {
        const isActiveTab = computed(() => props.activeTab === props.index);
        const isLastTab = computed(() => props.index === props.totalTabs - 1);

        const tabClicked = () => {
            if (props.clickable) {
                emit('click', props.index);
            }
        };
        return { isActiveTab, isLastTab, tabClicked };
    },
});
